import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useTheme } from "@mui/material";

export default function DeleteDialog(props) {
  const theme = useTheme();

  const handleClose = () => {
    props.function();
    props.setOpen();
  };

  return (
    <Dialog open={props.open} onClose={() => props.setOpen()}>
      <DialogTitle>{props.title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{props.text}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => props.setOpen()}
          sx={{ color: theme.palette.mode === "dark" ? "#c4c4c4" : "#666666" }}
        >
          Abbrechen
        </Button>
        <Button onClick={handleClose}>Archivieren</Button>
      </DialogActions>
    </Dialog>
  );
}
